import { hsCodeIdFormat } from "@redotech/redo-model/ids";
import { HsCodeSchema } from "@redotech/redo-model/inventory/attributes";
import { RedoFinderLoadTypeSchema } from "@redotech/redo-model/redo-finder-load";
import * as z from "zod";

const HsCodeItemSchema_ = HsCodeSchema.extend({ hasChildren: z.boolean() });
export const HsCodeItemSchema: z.ZodType<HsCodeItem> = HsCodeItemSchema_;
export interface HsCodeItem extends z.infer<typeof HsCodeItemSchema_> {}

const ParentHsCodeSchema_ = z.object({
  id: hsCodeIdFormat.schema,
  parentId: hsCodeIdFormat.schema.nullable(),
});
export const ParentHsCodeSchema: z.ZodType<ParentHsCode> = ParentHsCodeSchema_;
export interface ParentHsCode extends z.infer<typeof ParentHsCodeSchema_> {}

export const getHsCodes = {
  name: "getHsCodes" as const,
  input: z.object({
    id: hsCodeIdFormat.schema.optional(),
    loadType: RedoFinderLoadTypeSchema,
  }),
  output: z.object({
    path: z.array(
      z.object({
        parent: ParentHsCodeSchema.nullable(),
        children: z.array(HsCodeItemSchema),
      }),
    ),
  }),
};
